import { render, staticRenderFns } from "./DropDownBox.vue?vue&type=template&id=010e1a1b&scoped=true&"
import script from "./DropDownBox.vue?vue&type=script&lang=js&"
export * from "./DropDownBox.vue?vue&type=script&lang=js&"
import style0 from "./DropDownBox.vue?vue&type=style&index=0&id=010e1a1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e1a1b",
  null
  
)

export default component.exports